(function () {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
        'Showing {{(($ctrl.page-1) * $ctrl.limit)==0 ? 1:(($ctrl.page-1) * $ctrl.limit)}} - ' +
        '{{($ctrl.page * $ctrl.limit) < $ctrl.queryCount ? ($ctrl.page * $ctrl.limit) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            limit: '<'
        }
    };

    angular
        .module('jotApp')
        .component('jhiItemCount', jhiItemCount);
})();
